<template>
  <div class="has-background-white pa-md">
    <!-- Filters -->
    <div class="columns is-vcentered">
      <div class="column is-one-quarter">
        <BillingPeriodSelect status="open" v-model="billingPeriod" :size="null" @input="loadWeeks"/>
      </div>
      <div class="column is-one-quarter">
        <b-select v-model="metric">
          <option value="hours">Billable Hours</option>
          <option value="billed">Billable Amounts ($)</option>
        </b-select>
      </div>
    </div>
    <!-- Table Content -->
    <div class="table is-narrow is-size-7" v-if="!loading && billingPeriod">
      <table class="table is-fullwidth is-striped is-narrow is-size-8 border is-vcentered is-striped">
        <thead>
          <tr>
            <th style="width:40%">Partner</th>
            <th class="has-text-centered">Rate</th>
            <th v-for="(week, index) in weeks" :key="index"  class="has-text-centered">
              {{  $dates(week.start_date).format('MMM D') }} - {{ $dates(week.end_date).format('MMM D') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(seat, index) in seats" :key="index">
            <td>
              <p>{{  seat.contributor  }}</p>
              <p class="has-text-grey-light is-size-8">{{  seat.role  }}</p>
            </td>
            <td class="has-text-centered">
              <p><Currency :value="seat.cost_rate" /> / <Currency :value="seat.bill_rate" /></p>
            </td>
            <td v-for="(week, i) in seat.weeks" :key="i" class="has-text-centered">
              <Currency v-if="metric === 'billed'" :value="week.billable_total" />
              <Hours v-else-if="metric === 'hours'" :value="week.hours_billable" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="py-6 has-text-centered">
      Loading...
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BillingPeriodSelect from '@/components/Models/BillingPeriod/SelectMenu'

export default {
  components: {
    BillingPeriodSelect
  },
  computed: {
    ...mapGetters(['api']),
    loading () {
      return Boolean(this.loadingWeeks || this.loadingReport)
    }
  },
  data () {
    return {
      loadingReport: false,
      billingPeriod: null,
      budgetType: 'time',
      metric: 'billed',
      report: null,
      weeks: [],
      seats: []
    }
  },
  methods: {
    loadWeeks () {
      this.loadingWeeks = true
      this.weeks = []
      const endpoint = this.api.base + 'weeks'
      const query = {
        params: {
          billing_period_id: this.billingPeriod.id
        }
      }
      this.$http.get(endpoint, query).then(response => {
        this.weeks = response.data
        this.loadProjectWeeks()
        this.loadingWeeks = false
      })
    },
    loadProjectWeeks () {
      this.loadingReport = true
      this.seats = []
      const endpoint = this.api.route + '/projects/' + this.project.id + '/weeks'
      const query = {
        params: {
          billing_period_id: this.billingPeriod.id
        }
      }
      this.$http.get(endpoint, query).then(response => {
        this.report = response.data
        for (const position of response.data.positions) {
          if (position.type === this.budgetType && position.seats.length) {
            for (const seat of position.seats) {
              const row = {
                contributor: seat.contributor.user.full_name,
                role: seat.role,
                cost_rate: seat.plan_bill_rate,
                bill_rate: seat.plan_bill_rate,
                weeks: {}
              }
              for (const week of this.weeks) {
                row.weeks[week.id] = {
                  week_id: week.id,
                  start: this.$dates(week.start_date).format('MMM D'),
                  end: this.$dates(week.end_date).format('MMM D'),
                  billable_total: 0,
                  hours_billable: 0,
                }
                for (const timesheet of seat.timesheets) {
                  for (const tsWeek of timesheet.weeks) {
                    if (tsWeek.week_id === week.id) {
                      row.weeks[week.id].billable_total = tsWeek.billable_total
                      row.weeks[week.id].hours_billable = tsWeek.hours_billable
                    }
                  }
                }
              }
              this.seats.push(row)
            }
          }
        }
        this.loadingReport = false
      })
    }
  },
  props: {
    project: {
      type: Object,
      required: true
    },
    startBillingPeriod: {
      type: Object,
    },
    endBillingPeriod: {
      type: Object,
    },
    focusBillingPeriod: {
      type: Object,
    }
  }
}
</script>
